/**
 * As duas faixas de texto do alto das caixas de conferência.
 *
 * Papel: reproduz o aviso amarelo das importações (l. 840, 4318) — 12 px,
 * `8px 10px`, raio de 6 px, 10 px abaixo, fundo `--emb-aviso-fundo` e texto
 * `--emb-aviso-texto` — e, na mesma geometria, a faixa azul da guia DAE de
 * Outros Bancos (l. 902), com o texto em `--foreground`.
 *
 * Como usar: o aviso só é montado quando há o que avisar; a faixa informativa
 * está sempre na caixa dela.
 */
import { type ReactNode } from 'react';

/**
 * O aviso amarelo de uma conferência.
 *
 * @param children - O texto do aviso.
 * @returns A faixa.
 */
export function AvisoDeConferencia({ children }: { children: ReactNode }) {
  return (
    <div className="mb-2.5 rounded-[6px] bg-emb-aviso-fundo px-2.5 py-2 text-[12px] text-emb-aviso-texto">
      {children}
    </div>
  );
}

/**
 * A faixa azul, que explica e não avisa.
 *
 * @param children - O texto, que pode ter o nome em negrito.
 * @returns A faixa.
 */
export function CaixaInformativa({ children }: { children: ReactNode }) {
  return (
    <div className="mb-2.5 rounded-[6px] bg-emb-info-fundo px-2.5 py-2 text-[12px] text-foreground">
      {children}
    </div>
  );
}
